import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { selectInvestPlatform } from "./selector";
import { requestScenarioOptions, requestUserInvestPlatform } from "./actions";
import { useUser } from "@ls/user-module";

export const useUserPlatformEffect = () => {
  const user = useUser();
  const username = user?.username;

  const dispatch = useDispatch();
  useEffect(() => {
    if (username) {
      dispatch(requestUserInvestPlatform(username));
    }
  }, [username, dispatch]);
};

export const useUserScenarioOptionsEffect = () => {
  let userInvestPlatform = useSelector(selectInvestPlatform);
  const dispatch = useDispatch();
  //userInvestPlatform from the Api gives empty string if it doesnt exist and a number if only one id is present and gives in normal cases comma seperated values csv
  if (typeof userInvestPlatform === "number")
    userInvestPlatform = userInvestPlatform.toString();
  let platformIds =
    userInvestPlatform?.length > 0 ? userInvestPlatform?.toString() : void 0;
  useEffect(() => {
    if (platformIds && platformIds?.length !== 0) {
      dispatch(requestScenarioOptions(userInvestPlatform));
    }
  }, [userInvestPlatform, dispatch, platformIds]);
};
